// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2901":"11249dfa","3901":"dd607d0c"}[chunkId] + ".chunk.css";
};